module.exports = __webpack_public_path__ + "img/icon.62604b49.png";